import React, {useState} from "react";
import "./query.css";
import ConnectWithUs from "../../common_components/ConnectWithUs";
import Header from "../../common_components/Header";
import Footer from "../../common_components/Footer";
import { collectionGroup } from "firebase/firestore";
import {db} from './firebase'
import { collection, addDoc } from "firebase/firestore";


function Query() {

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')

  const [errorName, setErrorName] = useState('')
  const [errorEmail, setErrorEmail] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault();
    const queryCollectionRef = collection(db, "QueryForm")

    const branch = "VIT AP"    
    let check = false

    if (name.length <= 3) {
      setErrorName('Name must contain atleast 3 Characters')
      return;
    }

    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!email.match(validRegex)) {
      setErrorEmail("Enter a valid email address")
      return;
    }

    setErrorName('')
    setErrorEmail("")

    // sending data to database
    await addDoc(queryCollectionRef, {
      Name: name,
      Email: email,
      Message: message,
      Subject: subject,
      Branch: branch,
      Check: check,
      TimeStamp: new Date().getTime()
    })

    alert('Query Sent Succesfully')
  }

  return (
    <React.Fragment>
      <Header></Header>
      <div className="query-content">
        <div className="left-content" id="left-content">
          <div className="top-part">
            <h2>Let's Reconnect</h2>
            <p>Alumni Association</p>
          </div>
          <div className="middle-content"></div>
          <div className="bottom-part">
            <h2>VIT AP</h2>
            <p>
              A professional platform to connect, share and recreate wonderful
              memories with distinguished Alumni.
            </p>
          </div>
        </div>
        <div className="right-content">
          <div className="middle-content">
            <h3>Send us your query</h3>
            <div className="form">
              <form method="POST" id="query">
                <div className="form-group">
                  <input type="text" id="name" placeholder="Name *"
                  onChange={(e) => setName(e.target.value)}
                  required />
                </div>

                {
                  errorName.length > 0 ? <p style={{color: '#650010'}}>{errorName}</p> : ''
                }

                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter email"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                {
                  errorEmail.length > 0 ? <p style={{color: '#650010'}}>{errorEmail}</p> : ''
                }

                <div className="form-group">
                  <input
                    disabled
                    type="text"
                    placeholder="Vellore Institute of Technology AP"
                    name="branch"
                    id="branch"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Subject"
                    name="subject"
                    id="subject"
                    onChange={(e) => setSubject(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <textarea
                    placeholder="Message"
                    rows={5}
                    name="message"
                    id="message"
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>
                <button onClick={handleSubmit} type="submit" className="submit btn btn-primary">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <script src="https://www.gstatic.com/firebasejs/9.0.1/firebase-app.js"></script>
      <script src="https://www.gstatic.com/firebasejs/9.0.1/firebase-app-compat.js"></script>
      <script src="https://www.gstatic.com/firebasejs/9.0.1/firebase-firestore-compat.js"></script>
      <script src="https://www.gstatic.com/firebasejs/9.0.1/firebase-firestore.js"></script>
      <script src="assets/js/firebase/query.js"></script>
      <ConnectWithUs></ConnectWithUs>
      <Footer></Footer>
    </React.Fragment>
  );
}
export default Query;
